import { render, staticRenderFns } from "./EditFlyer.vue?vue&type=template&id=92f97208&scoped=true&"
import script from "./EditFlyer.vue?vue&type=script&lang=js&"
export * from "./EditFlyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f97208",
  null
  
)

export default component.exports